import * as React from 'react';
import { RadioButtonList, RadioButtonListProps } from '../inputs/RadioButton';
import { FormField } from './FormField';

type RadioButtonListFieldProps = RadioButtonListProps & {
    label:string
};

export function RadioButtonListField(props:RadioButtonListFieldProps)
{
    return (
        <FormField 
            label={props.label} 
            inputComponent={
                <RadioButtonList {...props} />
            }
            inErrorState={false}
            message=""
        />
    )
}